export function fmtCount(n: number): string {
  if (n >= 100000000) {
    return `${(n / 100000000).toFixed(2)}亿`;
  }
  if (n >= 10000) {
    const v = n / 10000;
    return `${v >= 100 ? Math.round(v) : v.toFixed(1)}万`;
  }
  return String(n);
}

export function fmtPercent(a: number, b: number): number {
  const total = a + b;
  if (total <= 0) return 50;
  return Math.round((a / total) * 100);
}

export function fmtSigned(n: number): string {
  return n >= 10000 ? `+${fmtCount(n)}` : `+${n}`;
}